import User from '@/users/entities/user'
import cloneDeep from 'lodash/cloneDeep'
import { Component, Prop, Vue, Ref } from 'vue-property-decorator'

@Component
export default class UserDialog extends Vue {

  @Ref()
  private validator!: ValidationObserver

  private dialog: boolean = false
  private editMode: boolean = false
  private user: User = new User()

  get roles() {
    const rs: Array<{ value: string, text: string }> = []
    if (this.$auth.isAdmin) {
      rs.push({ value: 'ADMIN', text: 'Admin' })
    }
    rs.push({ value: 'TENANT', text: 'Bearbeiter' })
    return rs
  }

  public create(user?: User) {
    this.user = user || new User()
    this.user.address.countryId = 'AT'
    this.dialog = true
    this.editMode = false
    this.reset()
  }

  public edit(user: User) {
    this.user = cloneDeep(user)
    this.dialog = true
    this.editMode = true
    this.reset()
  }

  public async save() {
    if (await this.validator.validate()) {
      this.$emit(this.editMode ? 'update' : 'save', this.user)
      this.dialog = false
    }
  }

  public cancel() {
    this.$emit('cancel')
    this.dialog = false
  }

  private reset() {
    if (this.validator) {
      this.validator.reset()
    }
  }
}
